import { createFileRoute } from "@tanstack/react-router";
import { Mitgliedschaft } from "@content";

export const Route = createFileRoute("/mitgliedschaft")({
    component: Mitgliedschaft
});
